// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__Hav6t","info":"PatientInfo_info__3LEZ9"};